import type { ImageArray } from "../../types/ImageArray"

const toImageData = (image: ImageArray): ImageData =>
  new ImageData(new Uint8ClampedArray(image.data), image.width, image.height)

export const ExportImage = async (
  image: ImageArray,
  contentType: "image/jpeg" | "image/png" = "image/png"
): Promise<Blob> => {
  const imageData = toImageData(image)

  if (typeof OffscreenCanvas !== "undefined") {
    const canvas = new OffscreenCanvas(imageData.width, imageData.height)
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)
    return canvas.convertToBlob({ type: contentType })
  }

  if (typeof document !== "undefined") {
    const canvas = document.createElement("canvas")
    canvas.width = imageData.width
    canvas.height = imageData.height
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (blob) {
          resolve(blob)
        } else {
          reject(new Error("Failed to create blob from canvas"))
        }
      }, contentType)
    })
  }

  throw new Error("No canvas implementation available")
}
